const EDITING_DOMAIN = 'editing'
const EDITING_STATE = {
  paths: []
}

export {
  EDITING_DOMAIN,
  EDITING_STATE
}
